import './ColumnNotification.css';
import './SendBriefing/SendBriefing.css';

import React, { useRef, useState } from 'react';

import BriefingsModal from './briefings/BriefingsModal';
import SearchUserModal from './briefings/SearchUserModal';
import { User } from '../../../redux/type';
import { epochToDateStringWithYear } from '../../../helper';

type Props = {
  allBriefings: any[];
  sendEmailApi: (briefingId: string) => void;
  sendBriefingEmailToPecificUsersApi: (
    briefingId: string,
    userIds: string[]
  ) => void;
};

const ColumnNotification: React.FC<Props> = ({
  allBriefings,
  sendEmailApi,
  sendBriefingEmailToPecificUsersApi,
}) => {
  // const [sentCount, setSentCount] = useState(0);
  // const [bounceCount, setBounceCount] = useState(0);
  const [isBriefingModalOpen, setIsBriefingModalOpen] = useState(false);
  const [isSearchUserModalOpen, setIsSearchUserModalOpen] = useState(false);
  const [selectedBriefing, setSelectedBriefing] = useState<number | null>(null);
  const userSelectClicked = useRef(false);

  const sendToAllBtnClick = () => {
    setIsBriefingModalOpen(true);
  };

  const sendSelectUserBtnClick = () => {
    userSelectClicked.current = true;
    setIsBriefingModalOpen(true);
  };

  const handleBriefingSelect = (briefingId: string) => {
    if (userSelectClicked.current) {
      setIsBriefingModalOpen(false);
      setIsSearchUserModalOpen(true);
      return;
    }
    sendEmailApi(briefingId);
    setIsSearchUserModalOpen(false);
  };

  const handleUserSelect = (users: User[]) => {
    if (selectedBriefing != null) {
      const userIds = users?.reduce((acc, item) => {
        acc.push(item.user_id);
        return acc;
      }, [] as string[]);
      sendBriefingEmailToPecificUsersApi(
        allBriefings[selectedBriefing].id,
        userIds
      );
    }
    userSelectClicked.current = false;
    setSelectedBriefing(null);
    setIsSearchUserModalOpen(false);
  };

  const closeBriefingModal = () => {
    setIsBriefingModalOpen(false);
    if (!userSelectClicked.current) {
      setSelectedBriefing(null);
    }
    userSelectClicked.current = false;
  };

  const closeUsersModal = () => {
    setIsSearchUserModalOpen(false);
    if (!userSelectClicked.current) {
      setSelectedBriefing(null);
    }
    userSelectClicked.current = false;
  };

  return (
    <div className="send-briefing-container">
      <div className="send-briefing-heading"> Briefing Notification</div>

      <div className="briefing-options-heading">
        Briefing Options (No Mails sent, yet)
      </div>

      <div
        className="sending-statistics-briefing"
        style={{ fontSize: 16, fontWeight: 700 }}
      >
        Sending statistics for Briefing
      </div>

      {/* <div className='email-stats-container'>
        <div className='stats-box'>
          <h3 style={{ color: '#636363', fontSize: 16, fontWeight: 600 }}>
            Send Mail
          </h3>
          <div className='count'>{sentCount}</div>
        </div>
        <div className='stats-box'>
          <h3 style={{ color: '#636363', fontSize: 16, fontWeight: 600 }}>
            Bouncing Mail
          </h3>
          <div className='count'>{bounceCount}</div>
        </div>
      </div> */}

      <div className="boxes-row">
        <div className="sendselect-box">
          <div className="send-box">
            <img src="./assets/sendBriefingsend.png" alt="Send to All" />
            <h3>Send Briefing to All Customers</h3>
            <p style={{ color: "#636363", fontSize: 14, fontWeight: 400 }}>
              Send your Briefing to all the customers present in the system
            </p>
            <button className="send-to-all-button" onClick={sendToAllBtnClick}>
              Send to All
            </button>
          </div>

          <div className="select-box">
            <img src="./assets/sendBriefingmail.png" alt="Select Users" />
            <h3>Send Briefing to selected users</h3>
            <p style={{ color: "#636363", fontSize: 14, fontWeight: 400 }}>
              Send your Briefing to selected users in the system
            </p>
            <button
              className="select-users-button"
              onClick={sendSelectUserBtnClick}
            >
              Select Users
            </button>
          </div>
        </div>
      </div>

      {isBriefingModalOpen && (
        <BriefingsModal
          allBriefings={allBriefings}
          selectedBriefing={selectedBriefing}
          setSelectedBriefing={setSelectedBriefing}
          closeModal={closeBriefingModal}
          handleBriefingSelect={handleBriefingSelect}
          epochToDateStringWithYear={epochToDateStringWithYear}
        />
      )}
      {isSearchUserModalOpen && (
        <SearchUserModal
          isOpen={isSearchUserModalOpen}
          closeModal={closeUsersModal}
          onUserSelect={handleUserSelect}
        />
      )}
    </div>
  );
};

export default ColumnNotification;
